import {
	createAsyncThunk, type Action, type AnyAction, configureStore, type DevToolsEnhancerOptions, type EnhancedStore,
	type MiddlewareArray, type Reducer, type ThunkMiddleware, type Middleware
} from "@reduxjs/toolkit";

export function createIdentityThunk<T>(actionType: string) {
	return createAsyncThunk(
		actionType,
		async (actionArg: T) => {
			return actionArg;
		}
	);
}

export function createIdentitySelector<S, T>() {
	return (state: S, value: T) => (value);
}

export type TMiddleware<TState, TAction extends Action = AnyAction> =
	MiddlewareArray<ThunkMiddleware<TState, TAction>[]>;

/* eslint-disable @typescript-eslint/no-explicit-any */
export let store: EnhancedStore<any, AnyAction, TMiddleware<any>>;
/* eslint-enable @typescript-eslint/no-explicit-any */

export const buildStore = <TState>(
	reducer: Reducer, devTools: DevToolsEnhancerOptions, middlewareArray: Middleware<unknown, TState>[]
)=> {
	store = configureStore({
		reducer,
		devTools,
		middleware: (getDefaultMiddleware) => getDefaultMiddleware({
			immutableCheck: true,
			serializableCheck: false
		}).prepend(middlewareArray)
	});
};
